module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG01a4fdf7030203f7af10314f19e6cfd3.01a4fdf7.png";